module.exports = __webpack_public_path__ + "img/add_circle_icon.27b8ddd6.svg";